import { render, staticRenderFns } from "./MarketingConsent.vue?vue&type=template&id=18576bb2&scoped=true"
import script from "./MarketingConsent.vue?vue&type=script&lang=js"
export * from "./MarketingConsent.vue?vue&type=script&lang=js"
import style0 from "./MarketingConsent.vue?vue&type=style&index=0&id=18576bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18576bb2",
  null
  
)

export default component.exports